import { render, staticRenderFns } from "./AddClassRegister.vue?vue&type=template&id=1677be24&scoped=true&"
import script from "./AddClassRegister.vue?vue&type=script&lang=js&"
export * from "./AddClassRegister.vue?vue&type=script&lang=js&"
import style0 from "./AddClassRegister.vue?vue&type=style&index=0&id=1677be24&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1677be24",
  null
  
)

export default component.exports